var ProductOptionsStrings = {
    pageTitle: function () { return 'DoorDash for Work Solutions'; },
    pageSubtitle: function () { return 'Choose the plan that fits your business needs'; },
    categoryEmployeeMeals: function () { return 'Employee Meal Ordering'; },
    categoryEmployeePerks: function () { return 'Employee Perks and Benefits'; },
    employeeMealSectionTitle: function () { return 'Employee Meal Ordering'; },
    employeeMealSectionSubtitle: function () {
        return 'Flexible and easy to use meal budgets for your employees';
    },
    smallTeam: function () { return 'Team'; },
    corporateOrdering: function () { return 'Enterprise'; },
    doordashForWorkPlatform: function () { return 'DoorDash for Work Platform'; },
    // eslint-disable-next-line prettier/prettier
    accountAndSupport: function () { return 'Account \& Support'; },
    benefitTeamSize: function () { return 'Team size'; },
    benefitTeamSizeSmallTeamLimit: function () { return 'Up to 200 employees'; },
    benefitTeamSizeCorporateLimit: function () { return 'Unlimited'; },
    benefitNumberOfMealBudgets: function () { return 'Number of meal budgets'; },
    benefitNumberOfMealBudgetsSmallTeamLimit: function () { return 'Up to 2 meal budgets'; },
    benefitNumberOfMealBudgetsCorporateLimit: function () { return 'Unlimited'; },
    benefitBudgetRestriction: function () { return 'Bugdet limit per person'; },
    benefitBudgetRestrictionSmallTeamLimit: function () { return 'Up to $40'; },
    benefitBudgetRestrictionCorporateLimit: function () { return 'Unlimited'; },
    benefitPaymentMethods: function () { return 'Payment methods'; },
    benefitPaymentMethodsSmallTeamLimit: function () { return 'Credit card only'; },
    benefitPaymentMethodsCorporateLimit: function () { return 'Credit card or invoicing'; },
    benefitEmployeeCanChoose: function () { return 'Employees can choose what to eat'; },
    benefitSpendingRules: function () { return 'Customize spending rules'; },
    benefitOnsiteAndRemoteEmployees: function () { return 'Good for onsite and remote employees'; },
    benefitEnterpriseIntegrations: function () { return 'Custom enterprise integrations'; },
    benefitAccountManager: function () { return 'Dedicated account management'; },
    benefitCustomerSupport: function () { return 'Priority customer support'; },
    benefitAvailability: function () { return 'Availability'; },
    benefitAvailabilitySmallTeamLimit: function () { return 'U.S. only'; },
    benefitAvailabilityCorporateLimit: function () { return 'U.S. and Canada'; },
    signUpNowButton: function () { return 'Get Started'; },
    contactSalesButton: function () { return 'Contact Sales'; },
    employeePerksSectionTitle: function () { return 'Employee Perks and Benefits'; },
    employeePerksSectionSubtitle: function () {
        return 'Show employees you care and attract top talent';
    },
    dashpassForWorkTileTitle: function () { return 'DashPass for Work'; },
    dashpassForWorkTileSubtitle: function () {
        return 'Make a DoorDash subscription part of your employee benefits package';
    },
    dashpassForWorkBenefitOne: function () { return '$0 Delivery fees'; },
    dashpassForWorkBenefitTwo: function () { return '5% credit back on eligible Pickup orders'; },
    dashpassForWorkBenefitThree: function () { return 'Great for distributed teams'; },
    dashpassForWorkBenefitFour: function () { return 'Pays for itself in 2 orders, on average'; },
    giftCardsTileTitle: function () { return 'Gift Cards'; },
    giftCardsTileSubtitle: function () {
        return 'Show your appreciation by treating your employees to their favorite meal with DoorDash gift cards.';
    },
    giftCardsBenefitOne: function () { return 'Non-expiring, so employees can enjoy anytime'; },
    gitftCardsBenefitTwo: function () {
        return 'Go the extra mile with a personal note to let employees know that you care';
    },
    benefitWhatIsIncluded: function () { return 'What’s Included:'; },
    benefitWhatIsExcluded: function () { return 'What’s Not Included:'; },
    giftCardButton: function () { return 'Get Started'; },
    supportSectionTitle: function () { return 'We’re here to help'; },
    supportSectionSubtitle: function () {
        return 'Have questions? Need help? You can talk to a member of our DoorDash for Work Sales team at any time.';
    },
    talkToSalesModalTitle: function () {
        return 'Our Sales team will reach out to set up your account';
    },
    talkToSalesModalContent: function () {
        return 'Thank you for your interest in setting up an Enterprise account. We will contact you within 24 hours to help you find the right DoorDash for Work solution for your team’s needs.';
    },
    talkToSalesModalConfirmButton: function () { return 'Got it'; },
};
export default ProductOptionsStrings;
